/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  $state,
  $stateParams,
  $filter,
  $timeout,
  $interval,
  cookies,
  webpage,
  eventService,
  projectService,
  workflowsService,
  ticketService,
  ticketsService,
  accountsService,
  filterService,
  filtersService,
  jobsService,
  jobTypesService,
  notesService,
  labelsService,
  partnersService,
  Color,
  NOTE,
  TICKET,
  ACCOUNT,
  PARTNER
) => {
  $scope.Model = {
    workflowsData: {
      available: [],
      current: null
    },
    ticketsData: {
      available: [],
      accounts: []
    },
    accounts: {
      available: []
    },
    labelsData: {
      available: []
    },
    jobTypesData: {
      available: []
    },
    filtersData: {
      available: [],
      current: null
    },
    filters: {
      idFilter: null,
      appliedName: null,
      isApplied: false,
      isReady: false
    },
    availableTileActions: [
      'add_note',
      'add_job',
      'select_labels',
      'move_to_another_workflow',
      'email_to_notes',
      'set_tile_color'
    ],
    boardHeight: null,
    availableTileColors: Color.available(),
    isReady: false
  };

  /*
   * Set webpage title
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');

  /*
   * Retrieve Available Workflows and Tickets Data
   * --------------------------------------------------------------------------------
   */
  const loadLabels = () =>
    labelsService
      .getAvailable({
        type: 'ticket',
        orderBy: 'name',
        coerceTo: 'string',
        isDescending: false,
        isActive: true
      })
      .then((labels) => {
        $scope.Model.labelsData.available = labels;
      });

  const loadJobTypes = () =>
    jobTypesService.getAvailable({ isActive: true }).then((jobTypes) => {
      $scope.Model.jobTypesData.available = jobTypes;
    });

  const loadTickets = (idFilter) =>
    ticketsService
      .getByWorkflow({
        idWorkflow: $stateParams.id,
        fields: TICKET.FIELDS.PROJECT,
        idFilter
      })
      .then((tickets) => {
        $scope.Model.ticketsData.available = tickets;

        const idAccounts = _.uniq(
          _.compact(_.flatten(_.map($scope.Model.ticketsData.available, 'idOwner')))
        );
        if (idAccounts.length) {
          accountsService
            .getSpecific({ ids: idAccounts, isActive: true, fields: ACCOUNT.FIELDS.LIST })
            .then((accounts) => {
              $scope.Model.ticketsData.accounts = accounts;
            });
        }
        $scope.projectInitialize();
      });

  const loadFilters = () =>
    filtersService.getAvailable({ type: 'ticket', isActive: true }).then((filters) => {
      $scope.Model.filtersData.available = filters;
    });

  const loadFilter = (idFilter) => {
    const deferred = $q.defer();
    filterService.readFilter({ id: idFilter }).then((filter) => {
      $scope.Model.filtersData.current = filter;
      deferred.resolve(filter);
    });
    return deferred.promise;
  };

  const loadWorkflows = () => {
    workflowsService.getAvailable({ isActive: true }).then((workflows) => {
      $scope.Model.workflowsData.available = workflows;
      $scope.Model.workflowsData.current = _.find(
        $scope.Model.workflowsData.available,
        (workflow) => workflow.id === $stateParams.id
      );

      webpage.pageTitle($scope.Model.workflowsData.current.name);

      accountsService
        .getSpecific({
          ids: $scope.Model.workflowsData.current.idTeamMembers,
          isActive: true,
          fields: ACCOUNT.FIELDS.LIST
        })
        .then((accounts) => {
          $scope.Model.accounts.available = accounts;
        });

      if (
        cookies.get(`stProjectFilter${btoa($scope.Model.workflowsData.current.id)}`) &&
        cookies.get(`stProjectFilter${btoa($scope.Model.workflowsData.current.id)}`) !==
          undefined &&
        JSON.parse(cookies.get(`stProjectFilter${btoa($scope.Model.workflowsData.current.id)}`))
          .idWfw === $scope.Model.workflowsData.current.id
      ) {
        $scope.Model.filters.idFilter = JSON.parse(
          cookies.get(`stProjectFilter${btoa($scope.Model.workflowsData.current.id)}`)
        ).idFil;
        loadFilter($scope.Model.filters.idFilter).then(() => {
          if ($scope.Model.filtersData.current.id !== undefined) {
            $scope.filtersApplied(
              $scope.Model.filtersData.current.id,
              $scope.Model.filtersData.current.name
            );
          } else {
            cookies.remove(`stProjectFilter${btoa($scope.Model.workflowsData.current.id)}`, {
              path: '/'
            });
            $scope.Model.filters.idFilter = null;
            loadTickets($scope.Model.filters.idFilter);
          }
        });
      } else {
        $scope.Model.filters.idFilter = null;
        loadTickets($scope.Model.filters.idFilter);
      }
    });
  };

  const initialize = () => {
    loadWorkflows();
    loadLabels();
    loadJobTypes();
    loadFilters();

    partnersService
      .getAvailable({ isActive: true, fields: PARTNER.FIELDS.CHIPS })
      .then((partners) => {
        $scope.Model.partnersData.available = partners;
      });
  };

  initialize();

  /*
   * Filters
   * --------------------------------------------------------------------------------
   */
  $scope.filterOpen = ($event) => {
    $event.stopPropagation();
    $scope.Model.filters.isReady = true;
  };
  $scope.filtersApplied = (idFilter, filterName) => {
    ticketsService.clearCache();
    filtersService.clearCache();

    $scope.Model.isReady = false;
    $scope.Model.filters.isApplied = idFilter !== null;
    $scope.Model.filters.appliedName = filterName;

    loadTickets(idFilter);
    loadFilters();
    if (idFilter !== null) {
      cookies.set(
        `stProjectFilter${btoa($scope.Model.workflowsData.current.id)}`,
        JSON.stringify({ idWfw: $scope.Model.workflowsData.current.id, idFil: idFilter }),
        { path: '/' }
      );
    } else {
      cookies.remove(`stProjectFilter${btoa($scope.Model.workflowsData.current.id)}`, {
        path: '/'
      });
    }

    $timeout(() => {
      $scope.Model.filters.isReady = false;
    }, 500);
  };
  $scope.filtersClosed = () => {
    $timeout(() => {
      $scope.Model.filters.isReady = false;
    }, 500);
  };

  /*
   * Methods
   * --------------------------------------------------------------------------------
   */
  $scope.isTicketEditAllowed = () =>
    $rootScope.CurrentAccount.isAdministrator ||
    $rootScope.CurrentOrganization.permissions.usersCanEditDeals;

  $scope.projectInitialize = () => {
    projectService.projectInitialize($scope.Model.ticketsData.available).then(() => {
      $timeout(() => {
        $scope.Model.boardHeight = projectService.getBoardHeight(
          $scope.Model.ticketsData.available,
          true
        );
        $interval(() => {
          $scope.Model.boardHeight = projectService.getBoardHeight(
            $scope.Model.ticketsData.available,
            true
          );
        }, 500);
        $scope.Model.isReady = true;
      });
    });
  };

  $scope.projectHasChanges = () => ticketsService.clearCache();

  $scope.getTicketsSumValue = (tickets, probability, format) =>
    projectService.getTicketsSumValue(tickets, probability, format);

  /*
   * Ordering Methods
   * --------------------------------------------------------------------------------
   */
  $scope.orderGetDirection = () => projectService.orderGetDirection();

  $scope.orderGetProperty = () => projectService.orderGetProperty();

  $scope.orderSetDirection = (ascending) =>
    projectService.orderSetDirection($scope.Model.ticketsData.available, ascending);

  $scope.orderSetProperty = (prop) =>
    projectService.orderSetProperty($scope.Model.ticketsData.available, prop);

  /*
   * Note Events
   * --------------------------------------------------------------------------------
   */
  $scope.noteAdd = ($event, note, ticket) => {
    eventService.noteEdit({
      event: $event,
      note,
      list: null,
      url: NOTE.API.UPLOAD,
      ticket,
      title: 'Drag & Drop file(s) here, or click to browse',
      allowedMimeTypes: '',
      allowedExtensions: ''
    });
  };

  $scope.noteEdited = (note) => {
    const noteEdited = note;
    notesService.clearCache();
    if (noteEdited.isNew === true) {
      delete noteEdited.isNew;
    }
  };

  /*
   * Job Events
   * --------------------------------------------------------------------------------
   */
  $scope.jobAdd = ($event, job, ticket) => {
    eventService.jobEdit({
      event: $event,
      job,
      isJob: true,
      showAccounts: true,
      showTicket: true,
      isTasksPage: false,
      stage: null,
      jobTypes: $scope.Model.jobTypesData.available,
      accounts: $scope.Model.accounts.available,
      workflow: $scope.Model.workflowsData.current,
      ticket
    });
  };

  $scope.jobEdited = (job) => {
    const jobEdited = job;
    jobsService.clearCache();
    if (jobEdited.isNew === true) {
      delete jobEdited.isNew;
    }
  };

  /*
   * Labels Events
   * --------------------------------------------------------------------------------
   */
  $scope.ticketLabelsSelect = ($event, ticket) =>
    eventService.dialogLabelSelect({
      event: $event,
      labels: $scope.Model.labelsData.available,
      selectedLabels: ticket.idLabels,
      data: ticket
    });

  $scope.ticketLabelsSelected = (selectedLabels, data) => {
    const ticket = data;
    ticket.idLabels = selectedLabels;
    ticketsService.clearCache();
    ticketService.updateTicket({ id: ticket.id, idLabels: ticket.idLabels });
  };

  /*
   * Move ticket to another workflow Events
   * --------------------------------------------------------------------------------
   */
  $scope.ticketMoveToAnotherWorkflow = ($event, ticketToMove) => {
    const ticket = {
      id: ticketToMove.id,
      idWorkflow: ticketToMove.idWorkflow,
      idStage: ticketToMove.idStage,
      idOwner: ticketToMove.idOwner,
      name: ticketToMove.name
    };
    $event.stopPropagation();
    ticketService
      .ticketMoveToAnotherWorkflow({
        event: $event,
        ticket,
        workflow: $scope.Model.workflowsData.current,
        workflows: $scope.Model.workflowsData.available,
        accounts: $scope.Model.accounts.available
      })
      .then((result) => {
        $scope.projectHasChanges();
        const workflowToMove = _.find(
          $scope.Model.workflowsData.available,
          (w) => w?.id === result.idWorkflow
        );
        $timeout(() => {
          $state.transitionTo(workflowToMove?.isProject ? 'project' : 'board', {
            id: result.idWorkflow
          });
        }, 1000);
      });
  };
};
